<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "App",
  created() {
    var protocolStr = document.location.protocol;
    if(protocolStr == "http:")
    {
      window.location.href=window.location.href.replace("http","https")
    }
  },
}
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?62f4be27c7830eb680747e0a48e57823";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
</script>
